/* eslint-disable no-undef */
/* eslint-disable no-underscore-dangle */
import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchFirebaseMarkers } from '../../redux/myMapsSlice'
import FirebaseMarker from '../FirebaseMarker/FirebaseMarker'

export default function FirebaseStops({ map }) {
  const dispatch = useDispatch()
  //   const { firebaseMarkersLoading } = useSelector((s) => s.maps)

  React.useEffect(() => {
    dispatch(fetchFirebaseMarkers())
  }, [])

  return <FirebaseMarkers map={map} />
}

function FirebaseMarkers({ map }) {
  const { firebaseMarkers } = useSelector((s) => s.maps)

  return (
    <>
      {firebaseMarkers.map((stop) => (
        <FirebaseMarker key={stop.id} stop={stop} map={map} />
      ))}
    </>
  )
}
